import React from 'react';

class ThSensorIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40 74C58.7777 74 74 58.7777 74 40C74 21.2223 58.7777 6 40 6C21.2223 6 6 21.2223 6 40C6 58.7777 21.2223 74 40 74Z"
          fill="#F7F4F1"
        />
        <path
          d="M39.9961 74.8C20.9201 74.8 5.33406 59.348 5.20006 40.242C5.06806 21.054 20.5701 5.33395 39.7581 5.19995C39.84 5.19995 39.9221 5.19995 40.0041 5.19995C59.0801 5.19995 74.6661 20.652 74.8 39.758C74.9341 58.946 59.4321 74.666 40.2421 74.8C40.1601 74.8 40.0781 74.8 39.9961 74.8ZM6.80006 40.23C6.92606 58.456 21.7981 73.2 39.9961 73.2C40.0761 73.2 40.1521 73.2 40.2301 73.2C58.536 73.072 73.326 58.076 73.1981 39.77C73.0721 21.544 58.2001 6.79995 40.0021 6.79995C39.9221 6.79995 39.8461 6.79995 39.7681 6.79995C21.4641 6.92795 6.67406 21.926 6.80006 40.23Z"
          fill="#84827E"
        />
        <path
          d="M43.6962 38.738V26.842C43.6962 24.81 42.0322 23.146 40.0002 23.146C37.9682 23.146 36.3042 24.81 36.3042 26.842V38.738C34.4382 39.95 33.2002 42.044 33.2002 44.434C33.2002 48.19 36.2442 51.234 40.0002 51.234C43.7562 51.234 46.8002 48.19 46.8002 44.434C46.8002 42.044 45.5602 39.95 43.6962 38.738Z"
          fill="url(#paint0_linear_241_696)"
        />
        <path
          d="M40.0002 62.334C41.2252 62.334 42.2182 61.3409 42.2182 60.116C42.2182 58.891 41.2252 57.8979 40.0002 57.8979C38.7753 57.8979 37.7822 58.891 37.7822 60.116C37.7822 61.3409 38.7753 62.334 40.0002 62.334Z"
          fill="url(#paint1_linear_241_696)"
        />
        <path
          d="M40.8857 40.858V30.2901C40.8857 29.8001 40.4877 29.4041 39.9997 29.4041C39.5117 29.4041 39.1137 29.8021 39.1137 30.2901V40.858C37.5037 41.256 36.3057 42.7 36.3057 44.434C36.3057 46.476 37.9597 48.13 40.0017 48.13C42.0437 48.13 43.6977 46.476 43.6977 44.434C43.6977 42.7 42.4997 41.256 40.8897 40.858H40.8857Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_241_696"
            x1="35.113"
            y1="25.6582"
            x2="51.4516"
            y2="34.7326"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_696"
            x1="38.4062"
            y1="58.2947"
            x2="41.4173"
            y2="61.7487"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default ThSensorIcon;
